import moment from 'moment'
export const PRODUCTION = true;

const Globals = {
  datePickerRanges: {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment()],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
    'This Year': [moment().startOf('year'), moment().endOf('year')],
    'Last Year': [
      moment().subtract(1, 'year').startOf('year'),
      moment().subtract(1, 'year').endOf('year'),
    ],
  },
  BASE_URL: PRODUCTION ? process.env.REACT_APP_BASE_URL_LIVE : process.env.REACT_APP_BASE_URL,
  API_END_POINT: PRODUCTION ? process.env.REACT_APP_API_END_POINT_LIVE : process.env.REACT_APP_API_END_POINT,
  APP_CHAT_PORT: PRODUCTION ? process.env.REACT_APP_CHAT_PORT_LIVE : process.env.REACT_APP_CHAT_PORT,
}
export default Globals;